const DatasetActionTypes = {
  FETCH_DATASET_START: "FETCH_DATASET_START",
  FETCH_DATASET_SUCCESS: "FETCH_DATA_SUCCESS",
  FETCH_DATASET_FAILURE: "FETCH_DATA_FAILURE",
  RESET_ERROR: "RESET_ERROR",
};

export default DatasetActionTypes;
